import { type AppType } from "next/app";
import { type Session } from "next-auth";
import { SessionProvider } from "next-auth/react";
import { Ubuntu } from "next/font/google";
import "primeflex/primeflex.css";
import "primereact/resources/primereact.min.css"; //core css
import "primeicons/primeicons.css"; //icons
// import "primereact/resources/themes/mdc-light-deeppurple/theme.css"; //theme
// Custom SASS Theme (Uncomment the line below and comment the line above after following src/styles/primereact-theme/README.md)
//import "../styles/primereact-theme/my-theme-dark/theme.scss";
import "../styles/primereact-theme/my-theme-light/theme.scss";
import "../styles/globals.css";

import { trpc } from "../utils/trpc";
const ubuntu = Ubuntu({
  weight: ["400", "700"],
  subsets: ["latin"],
});

const MyApp: AppType<{ session: Session | null }> = ({
  Component,
  pageProps: { session, ...pageProps },
}) => {
  return (
    <>
      <style jsx global>{`
        html {
          font-family: ${ubuntu.style.fontFamily};
        }
      `}</style>
      <SessionProvider session={session}>
        <Component {...pageProps} />
      </SessionProvider>
    </>
  );
};

export default trpc.withTRPC(MyApp);
